export default class HeadAnimation
{
    static nodes = {
        head: document.querySelector('.head'),
        rightLamp: document.querySelector('.head__lamp-right img'),
        leftLamp: document.querySelector('.head__lamp-left img'),
        camera: document.querySelector('.head__camera img'),
    }

    headAnim() {
        HeadAnimation.nodes.head.addEventListener('mousemove', (ev) => {
            let fillWidth = window.innerWidth // ширина экрана

            if (fillWidth > 1100) {
                let cursorPos = ev.clientX // позиция курсора
                let center = fillWidth / 2 // точка центра экрана
                let shift = ((cursorPos / center * 100) - 100) // Процент смещения влево/вправо -100/100


                if (cursorPos > center) { // движение
                    HeadAnimation.nodes.rightLamp.style.transform = `translate3D(${shift / 80}%, 0, 0)`;
                    HeadAnimation.nodes.leftLamp.style.transform = `translate3D(${shift / 80}%, 0, 0)`;
                    HeadAnimation.nodes.camera.style.transform = `translate3D(-${shift / 50}%, 0, 0)`;

                } else {
                    HeadAnimation.nodes.rightLamp.style.transform = `translate3D(${shift / 80}%, 0, 0)`;
                    HeadAnimation.nodes.leftLamp.style.transform = `translate3D(${shift / 80}%, 0, 0)`;
                    HeadAnimation.nodes.camera.style.transform = `translate3D(${(-shift) / 50}%, 0, 0)`;

                }
            }
        });
    };
}
